import request from '@utils/request'
import formatDate from '@utils/format-date'
import addDays from 'date-fns/addDays'

export const state = {
  cached: getSavedState('merchant.cached'),
  cachedProducts: [],
  cachedPlans: [],
};

export const getters = {};

export const mutations = {
  CACHE_MERCHANT(state, currentMerchant) {
    state.cached = currentMerchant;
    saveState('merchant.cached', currentMerchant);
  },
  CACHE_MERCHANT_PRODUCTS(state, currentProducts) {
    state.cachedProducts = currentProducts
  },
  CACHE_PLANS(state, plans) {
    state.cachedPlans = plans
  },
};

export const actions = {
  /**
   * 更新商家資訊
   */
  updateMerchant({ commit }, merchantData = {}) {
    commit('CACHE_MERCHANT', merchantData)
  },
  /*
   * 取得商家資訊
   * */
  fetchMerchant({ commit }, { merchantAlias } = {}) {
    return request
      .get(`/${merchantAlias}`)
      .then((response) => {
        commit('CACHE_MERCHANT', response.items);
        return response
      });
  },
  /*
   * 取得所有商品資訊
   * */
  fetchProducts({ commit }, { merchantAlias } = {}) {
    return request
      .get(`/${merchantAlias}/products`)
      .then((response) => {
        commit('CACHE_MERCHANT_PRODUCTS', response);
        return response
      });
  },
  /*
   * 取得單一商品資訊
   * */
  fetchProduct({ commit }, { merchantAlias, productAlias } = {}) {
    return request
      .get(`/${merchantAlias}/product/${productAlias}`)
  },
  /*
   * 取得單一商品庫存
   * */
  fetchProductCapacity(
    { commit },
    {
      merchantAlias,
      productAlias,
      groupSize = 1,
      startDate = formatDate(new Date()),
      endDate = formatDate(addDays(new Date(), 120))
    } = {}
  ) {
    return request
      .post(`/${merchantAlias}/product/${productAlias}/getBookingCapacities`, {
        startDate,
        endDate,
        groupSize
      }, { errorHandle: true })
  },
  /*
   * 取得單一商品票種
   * */
  fetchProductParams({ commit }, { productId, merchantAlias } = {}) {
    return request
      .get(`/${merchantAlias}/product/${productId}/params`)
  },
  /*
   * 取得所有預付方案
   * */
  fetchPrepaids({ commit }, { merchantAlias } = {}) {
    return request
      .get(`/${merchantAlias}/prepaids`)
  },
  /*
   * 取得單一預付方案
   * */
  fetchPrepaid({ commit }, { merchantAlias, prepaidAlias } = {}) {
    return request
      .get(`/${merchantAlias}/prepaid/${prepaidAlias}`)
  },
  /**
   * 取得所有方案
   */
  fetchPlans({ commit }) {
    return request.get('/plan/list').then((response) => {
      const plans = response
      commit('CACHE_PLANS', plans)
      return plans
    })
  },
  registerMerchant({ commit }, submitData) {
    return request.post('/merchant/register', submitData)
      .then((response) => response)
      .catch((error) => {
        return Promise.reject(error)
      })
  },
};

// ===
// Private helpers
// ===

function getSavedState(key) {
  const localStorageItem = window.localStorage.getItem(key);

  if(!localStorageItem) {
    return undefined;
  }

  if(localStorageItem === 'undefined') {
    return undefined;
  }

  /* if(localStorageItem === 'true') {
   return true;
   }

   if(localStorageItem === 'false') {
   return false;
   }

   if(localStorageItem === 'null') {
   return null;
   } */

  /* return typeof localStorageItem === 'object'
   ? JSON.parse(localStorageItem)
   : localStorageItem */
  return typeof localStorageItem === 'string'
    ? JSON.parse(localStorageItem)
    : localStorageItem
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
